import MDSpinner from 'react-md-spinner';
import React from 'react';

export default ({ size, color }) => (
  <MDSpinner
    color1={color || '#213970'}
    color2={color || '#213970'}
    color3={color || '#213970'}
    color4={color || '#213970'}
    size={size}
  />
);
